import {StyleSheet} from 'react-native';

const ScanBarcodeHeaderStyle = StyleSheet.create({
  container: {alignItems: 'flex-start', paddingLeft: 20},
  titleStyle: {paddingBottom: 10},
  unableToScanText: {
    textAlign: 'left',
    textDecorationLine: 'underline',
  },
});

export {ScanBarcodeHeaderStyle};
